module.exports = __webpack_public_path__ + "static/media/close.23c60fb3.svg";